<template>
    <input
        ref="fileInput"
        type="file"
        name="file"
        :multiple="mode==='multiple'"
        @change="onFileChange($event)"
    />
</template>

<script>
const { urlPrefix } = process.env.projectConfig;

export default {
    props: {
        mode: {
            type: String,
            default: 'single',
        },
        validateCallback: {
            type: Function,
        },
        callback: {
            type: Function,
        },
        isValidate: {
            // 是否开启图片校验
            type: Boolean,
        },
        maxPic: {
            type: Number, /* 多图模式下控制最多上传的图片张数 */
        },
        validateRule: {
            type: Object,
        },
        // 默认不裁剪
        ratio: {
            type: Number,
            default: -1,
        },
        // 是否增加暗水印
        dgWaterMark: {
            type: Boolean,
            default: false,
        },
        currentLength: {
            type: Number,
        },
        needCut: {
            type: Boolean,
            default: false,
        },
        needBorder: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            imageWidth: 0,
            imageHeight: 0,
            cutPic: false,
        };
    },
    computed: {
        remainLength() {
            return this.maxPic - this.currentLength;
        },
    },
    methods: {
        // 图片校验函数
        validateImage(file) {
            // 自定义校验
            if (this.validateCallback) {
                return new Promise((res) => {
                    this.validateCallback(file, () => {
                        res();
                    });
                });
            }
            if (this.isValidate && this.validateRule) {
                // eslint-disable-next-line consistent-return
                return new Promise((res, rej) => {
                    const fileFormat = this.getFormat(file);
                    const { picMaxSize, picFormat } = this.validateRule.pic;
                    let errorMessage = '';
                    const reg = new RegExp(`(${picFormat.join('|')})`, 'i');
                    if (picFormat && picFormat.length) {
                        if (!reg.test(fileFormat)) {
                            errorMessage += '图片格式不符合要求\n';
                            return rej(errorMessage);
                        }
                    }
                    // pdf本不应该属于图片校验类型，强行放在图片校验里，目前先遇到pdf就res()
                    if (/pdf/i.test(fileFormat)) {
                        return res();
                    }
                    if (file.size > picMaxSize * 1024) {
                        errorMessage += `上传图片不能超过${picMaxSize / 1024}MB\n`;
                        return rej(errorMessage);
                    }
                    if (file.size > picMaxSize * 1024) {
                        return rej(errorMessage);
                    }
                    const url = window.URL.createObjectURL(file);
                    const image = new Image();
                    image.src = url;
                    image.onload = () => {
                        /* eslint-disable */
                        this.imageWidth = image.width;
                        this.imageHeight = image.height;
                        let {width, height, minWidth, maxWidth, minHeight, maxHeight} = this.validateRule;

                       if(width && height && !minWidth && !maxWidth && !minHeight && !maxHeight
                            && this.imageWidth >= width && this.imageHeight >= height && this.needCut) {
                            if(this.imageWidth > width || this.imageHeight > height) {
                                this.cutPic = true;
                            }
                        }else if (
                            (width && `${image.width}` !== `${ width}`) ||
                            ( height && `${image.height}` !== `${ height}`) ||
                            ( minWidth && image.width <  minWidth) ||
                            ( maxWidth && image.width >  maxWidth) ||
                            ( minHeight && image.height <  minHeight) ||
                            ( maxHeight && image.height >  maxHeight)
                        ) {
                            errorMessage += '上传图片宽高不符合要求\n';
                        }
                        /* eslint-enable */
                        if (errorMessage) {
                            this.cutPic = false;
                            return rej(errorMessage);
                        }
                        return res();
                    };
                });
            }
            return Promise.resolve();
        },

        validateRar(file) {
            if (this.validateCallback) {
                return new Promise((res) => {
                    this.validateCallback(file, () => {
                        res();
                    });
                });
            }
            if (this.isValidate && this.validateRule) {
                return new Promise((res, rej) => {
                    let errorMessage = '';
                    const { rarFormat, rarMaxSize } = this.validateRule.rar;
                    const format = this.getFormat(file);
                    if (rarFormat && rarFormat.length) {
                        if (!/(rar|zip)/i.test(format)) {
                            errorMessage += '文件格式不符合要求\n';
                        }
                    } else if (!/(rar|zip)/i.test(format)) {
                        errorMessage += '文件格式不符合要求\n';
                    }

                    if (file.size > rarMaxSize * 1024) {
                        errorMessage += `上传文件不能超过${(rarMaxSize / 1024).toFixed(3)}MB\n`;
                    }

                    if (errorMessage) {
                        return rej(errorMessage);
                    }
                    return res();
                });
            }
            return Promise.resolve();
        },

        // 添加图片函数
        onFileChange(e) {
            const files = e.target.files || e.dataTransfer.files;

            if (!files.length) return;
            if (files.length > this.remainLength) {
                this.$message.error(`选择文件数过多，超出剩余上传数量：${this.remainLength}`);
                e.target.value = '';
                return;
            }
            /* eslint-disable */
            for (let i = 0, file; (file = files[i++]);) {
                let validateResult = this.judgeFileFormat(file);
                if (!validateResult) {
                    this.$message({
                        type: 'error',
                        message: '文件格式不符合要求'
                    });
                    continue;
                }

                validateResult
                    .then(() => {
                        this.upload(file)
                        .then(data=>{
                            if(this.cutPic){
                                return this.$hPost(`${urlPrefix}/api/picture/cut`, {
                                    url: data.url,
                                    width: this.validateRule.width,
                                    height: this.validateRule.height
                                });
                            }else{
                                return data
                            }
                        })
                            .then(data => {
                                this.cutPicfalse
                                // 改API， 透传data
                                // this.$emit('getUrl', data.url);
                                let { width, height } = data;
                                this.$emit('getImgObj', Object.assign({}, { mimeType: file.type, height: this.imageHeight, width: this.imageWidth }, data));
                                if (this.callback) this.callback(data);
                            })
                            .catch(err => {
                                console.warn(err);

                                this.$message({
                                    type: 'error',
                                    message: `第${i}个${err.message || '文件上传失败'}`
                                });
                            });
                    })
                    .catch(err => {
                        console.warn('err', err);
                        this.$notify.error({
                            title: `错误：${file.name}`,
                            message: this.$validator.$errorMessage(err.split('\n'), '错误详情：'),
                            duration: 5000
                        });
                    });
            }
            /* eslint-enable */
            e.target.value = '';
        },

        // 图片上传函数
        upload(file) {
            const body = {
                file,
                ratio: this.ratio,
            };
            if (this.needBorder) { body.whitePicAdjust = true; }
            // 0310：暂时下掉暗水印入口
            // if (this.dgWaterMark) body.dgWaterMark = this.dgWaterMark;
            return this.$post({
                options: {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
                url: '/api/upload/picture.ajax',
                body,
            })
                .then((data) => {
                    let errorMsg = '';
                    if (this.mode === 'multi' && this.maxPic && this.imgArray.length > this.maxPic - 1) {
                        errorMsg = `不能超过${this.maxPic}张`;
                    }
                    if (!data.url) {
                        errorMsg = '上传失败，请重试';
                    }
                    if (errorMsg) {
                        throw new Error(errorMsg);
                    } else {
                        return data;
                    }
                })
                .catch((err) => {
                    throw err;
                });
        },

        judgeFileFormat(file) {
            const format = this.getFormat(file);

            if (/(png|jpe?g|gif|pdf)/i.test(format) && this.validateRule.pic) {
                return this.validateImage(file);
            }
            if (/(rar|zip)/i.test(format) && this.validateRule.rar) {
                return this.validateRar(file);
            }
            return false;
        },

        getFormat(file) {
            const { name } = file;
            return name.split('.')[name.split('.').length - 1];
        },
    },
};
</script>

<style lang="scss" scoped>
.el-notification__closeBtn {
    top: 5px;
    right: 5px;
}
</style>
